<template>
  <div class="boxbgcolor api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AllTree v-on:handleTreeClick="handleTreeClick"></AllTree>
    </div>
    <div class="right content-right configure-right">
      <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="payConfigure">
        <el-form-item label="商户代码" prop="merchantId">
          <el-input v-model="payConfigure.merchantId" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="商户柜台代码" prop="posId">
          <el-input v-model="payConfigure.posId" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="分行代码" prop="branchId">
          <el-input v-model="payConfigure.branchId" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="公钥" prop="pub">
          <el-input v-model="payConfigure.pub" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
          <span>|</span>
          <el-checkbox v-model="payConfigure.unconsciousPay" label="启用无感支付" name></el-checkbox>

          <el-checkbox
            v-if="showHandPay"
            v-model="payConfigure.unconsciousPayAuto"
            label="是否手动"
            name
          ></el-checkbox>
        </el-form-item>
      </el-form>
      <div class="submit">
        <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { ccbUnionConfigureOne, ccbUnionConfigureAddOrEdit } from "@/api/url";

import AllTree from "@/page/commons/allTree";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      fileList: [],
      payConfigure: {
        id: "",
        merchantId: "",
        posId: "",
        branchId: "",
        pub: "",
        openFlag: false,
        unconsciousPay: false,
        unconsciousPayAuto: false,

        parkingId: "",
      },
      showHandPay: false,
      rules: {
        merchantId: [
          { required: true, message: "请填写商户代码", trigger: "blur" },
        ],
        posId: [
          { required: true, message: "请填写商户柜台代码", trigger: "blur" },
        ],
        branchId: [
          { required: true, message: "请填写分行代码", trigger: "blur" },
        ],
        pub: [{ required: true, message: "请填写公钥后30位", trigger: "blur" }],
        // openFlag: [
        //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
        // ]
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.treeData.parkingId = "";
        this.payConfigure.merchantId = "";
        this.payConfigure.id = "";
        this.payConfigure.posId = "";
        this.payConfigure.branchId = "";
        this.payConfigure.pub = "";
        this.payConfigure.openFlag = false;
        // this.$message({
        //         message: '请选择车场！',
        //         type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(ccbUnionConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          // this.treeData.parkingId=data.data.parkingId;
          this.payConfigure.merchantId = data.data.merchantId;
          this.payConfigure.id = data.data.id;
          this.payConfigure.posId = data.data.posId;
          this.payConfigure.branchId = data.data.branchId;
          this.payConfigure.pub = data.data.pub;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
          this.payConfigure.unconsciousPay =
            data.data.unconsciousPay == "1" ? true : false;
          this.payConfigure.unconsciousPayAuto =
            data.data.unconsciousPayAuto == "1" ? true : false;
        } else {
          // this.treeData.parkingId='';
          this.payConfigure.merchantId = "";
          this.payConfigure.id = "";
          this.payConfigure.posId = "";
          this.payConfigure.branchId = "";
          this.payConfigure.pub = "";
          this.payConfigure.openFlag = false;
          this.payConfigure.unconsciousPay = false;
          this.payConfigure.unconsciousPayAuto = false;
          this.showHandPay = false;
        }
      });
      // console.log(this.payConfigure.openflag)
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          if (this.payConfigure.id) {
            this.$postRequest(ccbUnionConfigureAddOrEdit(), {
              id: this.payConfigure.id,
              parkingId: this.treeData.parkingId, //停车场ID
              merchantId: this.payConfigure.merchantId, //商户代码
              posId: this.payConfigure.posId, //商户柜台代码
              branchId: this.payConfigure.branchId, //分行代码
              pub: this.payConfigure.pub, //公钥后30位【PUB】
              openFlag: this.payConfigure.openFlag ? "y" : "n",
              unconsciousPay: this.payConfigure.unconsciousPay ? "1" : "0",
              unconsciousPayAuto: this.payConfigure.unconsciousPay
                ? this.payConfigure.unconsciousPayAuto
                  ? "1"
                  : "0"
                : "",
            }).then((data) => {
              //提交后的操作
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "修改配置成功!",
              });
            });
          } else {
            this.$postRequest(ccbUnionConfigureAddOrEdit(), {
              parkingId: this.treeData.parkingId, //停车场ID
              merchantId: this.payConfigure.merchantId, //商户代码
              posId: this.payConfigure.posId, //商户柜台代码
              branchId: this.payConfigure.branchId, //分行代码
              pub: this.payConfigure.pub, //公钥后30位【PUB】
              openFlag: this.payConfigure.openFlag ? "y" : "n",
              unconsciousPay: this.payConfigure.unconsciousPay ? "1" : "0",
              unconsciousPayAuto: this.payConfigure.unconsciousPay
                ? this.payConfigure.unconsciousPayAuto
                  ? "1"
                  : "0"
                : "",
            }).then((data) => {
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "新增配置成功!",
              });
            });
          }
        } else {
        }
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {
    handleUnconsciousPay() {
    
      return this.payConfigure.unconsciousPay;
    },
  },
  components: {
    AllTree,
  },

  mounted: function () {},
  watch: {
    handleUnconsciousPay: {
      handler: function (val) {
        if (val) {
          this.showHandPay = true;
        } else {
          this.showHandPay = false;
        }
      },
    },
  },
};
</script>

<style scoped>
.submit {
  text-align: center;
}
</style>
<style>
.api-configure .el-form {
  width: 70%;
  margin: 0 auto;
  margin-top: 50px;
}
.api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
}
.api-configure .el-form-item {
  margin-bottom: 30px;
}
.api-configure .el-form-item__label {
  height: 50px;
  line-height: 50px;
  color: #333 !important;
  font-weight: bold;
}
.submit .el-button {
  width: 200px;
  height: 50px;
}
.api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
</style>